import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'react-bootstrap';

const JobHistoryViewComponent = ({ jobScenarioMaps }) => {
  const title = 'Triggered Jobs History (total: ' + jobScenarioMaps.length + ')';
  return (
    <div>
      <fieldset>
        <legend>
          {title}
        </legend>
      </fieldset>
      <div>
        <div>
          <Row>
            <Col md={2} style={{ fontWeight: 'bold' }}>Job Link</Col>
            <Col md={2} style={{ fontWeight: 'bold' }}>Job Status</Col>
            <Col md={8} style={{ fontWeight: 'bold' }}>Reason</Col>
          </Row>
        </div>
        {
          jobScenarioMaps.map((jobScenarioMap, i) => {
            if (!jobScenarioMap) {
              return null;
            }

            return (
              <div key={i}>
                <Row>
                  <Col md={2}>
                    <a href={jobScenarioMap.jobLink}>{
                      `Job:${jobScenarioMap.jobNumber}`
                    }</a>
                  </Col>
                  <Col md={2}>{jobScenarioMap.jobScenario['status']} </Col>
                  <Col md={8}>{jobScenarioMap.jobScenario['reason']}</Col>
                </Row>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

JobHistoryViewComponent.propTypes = {
  jobScenarioMaps: PropTypes.arrayOf(
    PropTypes.shape({
      jobScenario: PropTypes.object,
      jobLink: PropTypes.string,
      jobNumber: PropTypes.string
    })
  )
};

export default JobHistoryViewComponent;


// WEBPACK FOOTER //
// src/Components/JobHistoryViewComponent.jsx